var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.34514 8.8334L8.58922 14.0775L7.41071 15.256L0.154785 8.00006L7.41071 0.744141L8.58922 1.92265L3.34514 7.16673H15.5V8.8334H3.34514Z","fill":"#8F8F92"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }